import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {NgClass} from "@angular/common";

@Component({
  selector: 'pf-link-out',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './link-out.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class LinkOutComponent {
  @Input() name?: string;
  @Input() link!: string;
  @Input() linkText!: string;
  @Input() additionalClasses: string[] | string = '';
  @Input() openNewTab = true;

  get id(): string | null {
    const normalized = this.name?.trim()?.replaceAll(/\s+/g, '-').toLowerCase();
    return normalized ? 'link-' + normalized : null;
  }
}